import dpiaRequestsApi from 'config/api/dpiaRequests/dpiaRequests';
import { pickCurrentDpiaIdFromHistory } from 'config/api/dpiaRequests/dpiaRequests.helpers';

export const startDpiaReassessment = async (organizationId: number, apaId: number, reason: string): Promise<number> => {
  await dpiaRequestsApi.reassess(organizationId, apaId, { reason });
  const { data } = await dpiaRequestsApi.getDpiaHistory(organizationId, apaId);
  const currentId = pickCurrentDpiaIdFromHistory(data.items);

  if (!currentId) {
    throw new Error('Reassessment succeeded but no current DPIA was returned');
  }

  return currentId;
};

export default startDpiaReassessment;
